








































































import RouteTab from '@/components/RouteTab.vue';
import { Component, Vue, Emit, Watch } from 'vue-property-decorator';
import EscalatedAlertTable from './escalated-alert-table.vue';
import CircularProgress from './circle-progress.vue';
import { EscalatedAlertApiService } from '@/services/escalated-alert-service';
import Toast from '@/components/display/toast.vue';
import { EscalatedAlert, EscalatedAlertCounts, EscalatedAlertStatus } from '@/api';

@Component({
	components: {
		RouteTab,
		CircularProgress,
		EscalatedAlertTable,
	},
})
export default class EscalatedAlertTableTab extends Vue {
	// API / API management & return fields
	public escalatedAlertApi: EscalatedAlertApiService = new EscalatedAlertApiService();
	public toast: Toast = new Toast();
	public alerts: EscalatedAlert[] = [];
	public loading: boolean = false;
	public failure: boolean = false;

	// Pagination Fields
	public currentPage: number = 1;
	public totalRows: number = 0;

	public badges: EscalatedAlertCounts | null = null;

	public get pageStatus(): EscalatedAlertStatus {
		return this.$route.meta.alertStatus || EscalatedAlertStatus.New;
	}

	public get perPage(): number {
		return this.pageStatus === EscalatedAlertStatus.Resolved ? 15 : 50;
	}

	public sort(): string {
		return this.pageStatus === EscalatedAlertStatus.New ? 'created_at' : '-updated_at';
	}

	@Watch('pageStatus')
	public resetCurrentPage() {
		if (this.currentPage === 1) this.loadEscalatedAlerts();
		else this.currentPage = 1;
	}

	@Watch('currentPage')
	public async loadEscalatedAlerts() {
		const status = this.pageStatus;
		const page = this.currentPage;
		this.loading = true;
		const { escalatedAlerts, errorMessage } = await this.escalatedAlertApi.getEscalatedAlerts({
			params: {
				include: 'product, event, logs, entity.currententitystate',
				'filter[status]': this.pageStatus,
				perPage: this.perPage,
				page: this.currentPage,
				sort: this.sort(),
			},
		});

		if (status !== this.pageStatus || page !== this.currentPage) return;
		if (escalatedAlerts != null) {
			this.alerts = escalatedAlerts.data ?? [];
			this.totalRows = escalatedAlerts.meta.total;
			this.failure = false;
		} else if (errorMessage) {
			this.failure = true;
			this.alerts = [];
			this.toast.makeToast(errorMessage, 'Escalated Alerts Error', 'danger');
		}
		this.loading = false;
	}

	public async loadEscalatedAlertsCounts() {
		const {
			escalatedAlertsCounts,
			errorMessage,
		} = await this.escalatedAlertApi.getEscalatedAlertsCounts();

		if (escalatedAlertsCounts != null) {
			this.badges = escalatedAlertsCounts;
		} else if (errorMessage) {
			this.toast.makeToast(errorMessage, 'Escalated Alerts Error', 'danger');
		}
	}

	public handleReload() {
		this.loadEscalatedAlerts();
		this.loadEscalatedAlertsCounts();
	}

	public async mounted() {
		this.loadEscalatedAlerts();
		this.loadEscalatedAlertsCounts();
	}

	@Emit('alert-selection')
	public handleTablePress(alert: EscalatedAlert) {
		return alert;
	}

	public beforeDestroy() {
		clearInterval(this.interval);
	}
}
